import { EventAction } from 'Api/Contracts/Dtos/Project/EventAction';

export class EventActionGroup extends EventAction {
    public constructor(
        actionName: string,
        name: string,
        actions: Array<EventAction>
    ) {
        super(actionName, name, null, null, null);
        this.eventActions = actions;
    }

    public eventActions: Array<EventAction>;
}
